import { render, staticRenderFns } from "./SignInMethodIcon.vue?vue&type=template&id=2948a710&"
import script from "./SignInMethodIcon.vue?vue&type=script&lang=js&"
export * from "./SignInMethodIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports